<template>
  <v-dialog v-model="showDialog" transition="slide-y-transition">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon dark @click.native="close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <iframe :src="urlPath" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'IframeDialog',
  data() {
    return {
      showDialog: false,
      urlPath: '',
      title: ''
    }
  },
  methods: {
    close() {
      this.showDialog = false
    },
    setData(title, url) {
      this.title = title
      this.urlPath = url
      this.showDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog {
  height: 99vh;
  width: 99vw;
  position: relative;

  iframe {
    width: 100%;
    border: none;
    height: 80vh;
  }
}
</style>
